import 'store/bolt/pixels.js';
import Store from 'store/store';

Store.on('TEXT_PAGE_TICKET_LINK_CLICK', () => {
	Store.emit('POWSTER_GA_EVENT_TRACK', 'location-click', 'locations-page');
});
